import { useCustomJS, useDefineAPISchema } from '@elfsight/widget-js-api';
import { Portal, PortalNestProvider } from '@elfsight/widget-modal';
import {
  CustomCSS,
  createCustomCSSPrefixClassName,
  EmbedRoot,
  useFontsLoader
} from '@elfsight/widget-ui';
import { StorageProvider } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { camelCase } from 'es-toolkit';
import { meta } from '../constants';
import { ChannelsProvider } from './channels';
import { ChatProvider } from './chat';
import { Filters } from './filters';
import { Main } from './main';

interface FloatingWindowProps {
  customCSSPrefixClassName: string;
}

const FloatingWindow = ({ customCSSPrefixClassName }: FloatingWindowProps) => (
  <PortalNestProvider customCSSClassName={customCSSPrefixClassName}>
    <Portal>
      <Main />
    </Portal>
  </PortalNestProvider>
);

export const Chats = () => {
  const {
    widgetId,
    position,
    font,
    customCSS,
    customJS,
    editMode,
    renderThumbnailMode
  } = useSettings();

  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    meta.alias,
    widgetId
  );

  useDefineAPISchema();
  useFontsLoader([font]);
  useCustomJS(customJS, editMode || renderThumbnailMode);

  return (
    <StorageProvider
      widgetId={widgetId || 'mockId'}
      name={camelCase(meta.alias)}
    >
      <Filters>
        <ChatProvider>
          <ChannelsProvider>
            <CustomCSS
              customCSS={customCSS}
              prefixClassName={customCSSPrefixClassName}
            />
            {position === 'floating' ? (
              <FloatingWindow
                customCSSPrefixClassName={customCSSPrefixClassName}
              />
            ) : (
              <EmbedRoot
                fullWidth={false}
                customCSSClassName={customCSSPrefixClassName}
              >
                <Main />
              </EmbedRoot>
            )}
          </ChannelsProvider>
        </ChatProvider>
      </Filters>
    </StorageProvider>
  );
};
